import { render, staticRenderFns } from "./ProductDetailRedesign.vue?vue&type=template&id=acf049b0&"
import script from "./ProductDetailRedesign.vue?vue&type=script&lang=js&"
export * from "./ProductDetailRedesign.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailRedesign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports